/**
 * 渠道结构健康诊断 - 模拟数据
 * 首期用于前端独立演示，对接后端API后可删除
 */

// BRM 渠道数据索引（模拟从鹰智BRM数据库查询）
export const BRM_DB = {
  '蒙牛': {
    brand: '内蒙古蒙牛乳业(集团)股份有限公司',
    totalStores: 4476,
    authorizedStores: 800,
    grayListStores: 3676,
    dealerCount: 710,
    maxDealerDepth: 4,
    authRate: 18,
    platformsFound: ['京东商城', '淘宝网', '1688', '天猫商城', '其他'],
    platformsNotFound: ['拼多多', '抖音', '苏宁易购', '当当网'],
    platformDetails: {
      '京东商城': 1798, '淘宝网': 1005, '1688': 230, '天猫商城': 55, '其他': 1388
    },
    brmScores: {
      br1: { score: 3, note: 'BRM收录5个平台（京东/淘宝/天猫/1688/其他），拼多多/抖音/苏宁等未收录。' },
      fl2: { score: 1, note: 'BRM显示经销商层级最深4级，存在多级分销。' },
      de1: { score: 1, note: 'BRM显示授权率仅18%，灰名单3,676家(82%)。' },
      dv1: { score: 2, note: 'BRM仅收录货架电商平台。' },
      dv3: { score: 3, note: 'BRM显示京东店铺占可统计平台的40%。' }
    }
  }
}

// AI搜索数据（模拟实时网络调研结果）
export const BRAND_DB = {
  '蒙牛': {
    industry: '食品饮料',
    reasons: {
      br1: '天猫/京东/拼多多/抖音/快手/微信小程序均有布局，覆盖5+主流平台。',
      br2: '天猫设特仑苏/纯甄/未来星/真果粒等多品类旗舰店，京东开设官方旗舰店+冰淇淋自营旗舰店。',
      br3: '2025年布局即时零售/会员店/零食量贩等新兴渠道。',
      fl1: '抖音/快手直播带货、微信小程序直营，DTC渠道占比呈增长趋势。',
      fl2: '三级分销结构（生产商→分销商→二级批发商→零售商），存在优化空间。',
      fl3: '2025年"线上网销商+线下经销商"数据融合战略推行中。',
      de1: '授权店铺约800家，灰名单3,676家，授权率18%，管控力度不足。',
      de2: '多平台同品同价管控较弱，部分渠道间存在价格冲突。',
      de3: '各平台店铺以全品类铺货为主，差异化定位不明显。',
      dv1: '覆盖货架电商（天猫/京东/拼多多）、内容电商（抖音/快手）、社交电商（微信），业态较多元。',
      dv2: '内容→社交→货架链路初步形成，但闭环完整度待提升。',
      dv3: '单一平台GMV依赖度约40%以内（京东占比较突出），风险分散。',
      ft1: '常温/低温/乳饮三条产品线均有对应渠道覆盖，整体匹配度较高。',
      ft2: '客群覆盖Z世代至中年家庭用户，各平台客群均匹配。',
      ft3: '抖音/快手有专业直播团队，但部分新兴渠道人力投入不足。',
      ev1: '2025年启动"线上网销商+线下经销商"融合模式，处于渠道升级期。',
      ev2: '有经销商管理制度但复盘机制待完善。',
      ev3: '明确数字化转型+渠道升级方向，但缺乏量化路线图。'
    },
    findings: {
      tmall: { found: true, detail: '天猫多个品类旗舰店（特仑苏/纯甄/未来星/真果粒）' },
      jd: { found: true, detail: '京东官方旗舰店+冰淇淋自营旗舰店' },
      pdd: { found: true, detail: '拼多多官方认证旗舰店' },
      douyin: { found: true, detail: '抖音MENGNIUSTORE 277万粉丝 1159作品' },
      kuaishou: { found: true, detail: '快手蒙牛牛奶旗舰店 虚拟人直播' },
      xhs: { found: false, detail: '未找到明确官方账号' },
      miniapp: { found: true, detail: '微信小程序"蒙牛营养生活家"+"蒙牛品质生活"' },
      website: { found: true, detail: '官网 mengniu.com.cn' },
      app: { found: false, detail: '未找到独立App' },
      dealer: { found: true, detail: '三级分销结构（生产商→分销商→二级批发商→零售商），有经销商管理制度' },
      live: { found: true, detail: '抖音/快手均有直播带货' },
      community: { found: true, detail: '深化即时零售/会员店/零食量贩渠道合作' },
      strategy: { found: true, detail: '2025年"线上网销商+线下经销商"模式，数字化转型+渠道升级' }
    },
    scores: {
      br1: 5, br2: 4, br3: 4,
      fl1: 4, fl2: 2, fl3: 3,
      de1: 2, de2: 3, de3: 3,
      dv1: 5, dv2: 4, dv3: 3,
      ft1: 4, ft2: 4, ft3: 3,
      ev1: 4, ev2: 3, ev3: 3
    }
  }
}
